import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import imageGallery from '../views/ImageGallery.vue'
import Profile from '../views/Profile.vue'
import contentManagement from '../views/controlPanel/contentManagement.vue'
import FileManager from '../views/controlPanel/FileManager.vue'


const routes = [
  {
    path: '/controlPanel/contentManagement',
    name: 'contentManagement',
    component: contentManagement,
    meta: {
      label: ' ',
      requiresAuth: true
    }
  },
  {
    path: '/controlPanel/FileManager',
    name: 'FileManager',
    component: FileManager,
    meta: {
      label: ' ',
      requiresAuth: true
    }
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile,
    meta: {
      label: ' ',
      requiresAuth: true
    }
  },
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      label: ' ',
      requiresAuth: true
    },
  },

  {
    path: '/gallery',
    name: 'gallery',
    component: imageGallery,
    meta: {
      label: ' ',
      requiresAuth: true
    },
  },
  {
    path: '/about',
    name: 'about',
    meta: {
      label: ' ',
      requiresAuth: true
    },

    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 }
  },
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
